<template>
  <main>
    <router-view />
  </main>
</template>

<style>
body {
  margin: 0;
  background-color: #fbfbfb;
}

a {
  color: #07a;
}

button {
  cursor: pointer;
}

button[disabled] {
  cursor: default;
  color: #636363;
}

main {
  font-family: Verdana, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  line-height: 1.8;
}
</style>
